var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout__msg"},[_c('p',[_vm._v(_vm._s(_vm.__('Please confirm the order below.')))]),_vm._v(" "),_c('a',{staticClass:"button  btn  btn--tertiary",attrs:{"href":"/booking/pos"}},[_vm._v(_vm._s(_vm.__('Complete order')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102a2cc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Checkout/Gateway/Pos.vue
// module id = 3o0+
// module chunks = 116